import React, { useEffect, useRef } from "react";
import Heading from "../../tailwindUI/Heading";
import Navbar from "../../tailwindUI/Navbar";
import classes from "../../module.css/EdpDashboard.module.css";
import { useState } from "react";
import Input from "../../tailwindUI/Input";
import SuccessMessage from "../../tailwindUI/SuccessMessage";
import Button from "../../tailwindUI/Button";
import StatsCard from "../../tailwindUI/StatsCard";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
import EDPTableCopyClipBoard from "../../Components/EDPTableCopyClipBoard";
import Modal from "../../tailwindUI/Modal";
import { MdOutlineCancel } from "react-icons/md";
import EDPNewExcelEntry from "../../Components/EDPNewExcelEntry";

const EdpDashboard = () => {
  const navigate = useNavigate();
  const [input, setInput] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setloading] = useState(false);
  const [apiFailled, setApiFailled] = useState(false);
  const [error, setError] = useState({});
  const [uploadError, setUploadError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [eDPStockcountOfCarCount, setEDPStockcountOfCar] = useState({
    InTransitcar: "",
    PendingDeliveries: "",
    Pendingcar: "",
    Physicalcar: "",
    Totalcar: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState("");
  const [errorRreason, setErrorReason] = useState("");
  const [errors, setErrors] = useState({});
  // States
  const [initialData, setInitialData] = useState([]); // Original API data
  const [tableData, setTableData] = useState([]); // Editable table data
  const [newEntry, setNewEntry] = useState("");
  const [modelWiseDLD, setModelWiseDLD] = useState([]);
  const [totalStockModelWise, setTotalStockModelWise] = useState([]);
  const [edpfileupdateMessage, setEdpfileUpdateMessage] = useState("");
  const users = localStorage.getItem("UserToken");

  useEffect(() => {
    EDPStockcountOfCar();
    EDPstockdeliveredmodelwise();
  }, []);

  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/login", { replace: true });
  };

  const tableContainerRef = useRef(null);
  // const excelUpload = () => {
  //   setloading(true);
  //   var myHeaders = new Headers();
  //   myHeaders.append("Authorization", global.authToken);

  //   var formdata = new FormData();
  //   formdata.append("UserToken", users);
  //   formdata.append("Excel", input);

  //   var requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${global.apiBaseUrl}/api/v1/stockone/edp/EDPStockByExcel`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.status_code === 200 && result.status === "Success") {
  //         setMessage(result.message);
  //         setApiFailled(false);
  //       } else {
  //         setApiFailled(true);
  //         setMessage(result.Reason);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //       setErrorMessage("Something went wrong please contact support !");
  //     })
  //     .finally(() => setloading(false));
  // };

  console.log(initialData, "Initial data is")
  console.log(tableData, "Table data is")
  const updateExcel = (data) => {
    // setloading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);

    var formdata = new FormData();
    formdata.append("UserToken", users);

    formdata.append("data", JSON.stringify(data));

    // formdata.append("serializerdata", JSON.stringify(data));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/edp/EDPExcelStockUpdate`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        if (result.status_code === 200 && result.status === "Success") {
          if (
            result.message ==
            "Same Varient has in our database but sepcification code is different"
          ) {
            setErrorReason(
              "Please update Variant Name as same Variant Name already exists with a different Specification Code"
            );
            // setMessage("There is an error")
            // console.log(result.reason,"11111");
            setShowModal(true);
          } else {
            setErrorReason("");
            setReason("");
            setEdpfileUpdateMessage("Data updated successfully!");
            // setLoadingSignleData(false)
            // setTableData(result.data);
            setShowModal(false);
            setMessage("Data Updated Successfully");
            EDPNewEntry();
            EDPStockcountOfCar();
            EDPstockdeliveredmodelwise();
          }
          // setMessage(result.message);
          // setApiFailled(false);
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
          // setReason("There is an error!!");
          setErrorMessage("Something went wrong please contact support1 !");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => {
        setloading(false);
      });
  };
  const excelUpdate = () => {
    setloading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);

    var formdata = new FormData();
    formdata.append("UserToken", users);
    formdata.append("StockExcel", input);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/edp/EDPExcelStockAdd`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.message === "Update Varients"
        ) {
          setInitialData(
            result.ConcatVinData.map((item) => {
              return { ...item, enabled: true, error: "" };
            })
          );
          setTableData(
            result.ConcatVinData.map((item) => {
              return { ...item, enabled: true, error: "" };
            })
          );
          setShowModal(true);
          EDPNewEntry();
          EDPStockcountOfCar();
          EDPstockdeliveredmodelwise();

          setApiFailled(false);
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.message === "Stock not Found"
        ) {
          setMessage("Data Imported Successfully!");
          EDPStockcountOfCar();
          EDPNewEntry();
          EDPstockdeliveredmodelwise();
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.message === "Stock Already Exists"
        ) {
          setMessage("Stock Data Already Exists!");
          EDPStockcountOfCar();
          EDPNewEntry();
          EDPstockdeliveredmodelwise();
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => {
        setloading(false);
      });
  };



  const EDPNewEntry = () => {
    setloading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: users,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/edp/EDPExcelStockNewEntryList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "fail" &&
          result.data ===
          "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data === "You dont have permission to access model list" &&
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status_code === 200 && result.status === "Success") {
          setNewEntry(result.data);
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setloading(false));
  };

  const validateInput = () => {
    const newErrors = {};
    const selectedRows = tableData.filter((row) => row.enabled);

    // Collect all variant values for selected rows
    const variants = selectedRows.map((row) => row.Variant);

    tableData.forEach((row) => {
      if (!row.Variant) {
        // Check for empty input
        row["error"] = "Variant cannot be empty";
      } else if (
        variants.filter((variant) => variant === row.Variant).length > 1
      ) {
        // Check for duplicate Variant values
        row["error"] = "Variant must be unique";
      }
    });
    console.log(tableData);
    setErrors(newErrors);

    // Return true if no errors
    return tableData.filter((item) => item.error !== "").length === 0;
  };


  const EDPStockcountOfCar = () => {
    setloading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: users,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/edp/EDPStockcountOfCar`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "fail" &&
          result.data ===
          "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data === "You dont have permission to access model list" &&
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status_code === 200 && result.status === "Success") {
          setEDPStockcountOfCar({
            InTransitcar: result.InTransitcar,
            PendingDeliveries: result.PendingDeliveries,
            Pendingcar: result.Pendingcar,
            Physicalcar: result.Physicalcar,
            Totalcar: result.Totalcar,
          });
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setloading(false));
  };

  const EDPstockdeliveredmodelwise = () => {
    setloading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: users,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/edp/EDPstockdeliveredmodelwise`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data ===
          "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data === "You dont have permission to access model list" &&
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status === "Success") {
          setModelWiseDLD(result.stockdeliveredmodelwise);
          setTotalStockModelWise(result.freestock);
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setloading(false));
  };

  const successMessage = () => {
    setTimeout(() => {
      setMessage("");
    }, 3000);
    return message;
  };

  const handleChange = (event) => {
    event.target.files[0].name.match(/\.(xls[mx]?)$/)
      ? setInput(event.target.files[0])
      : setUploadError(
        "Please upload valid excel file .xlsx, .xlsm, .xls only."
      );
  };

  const formValidation = () => {
    let errors = {};
    let isValid = true;
    if (!input || input === "") {
      isValid = false;
      errors.input = "Please select a file";
    }
    setError(errors);
    return isValid;
  };

  const data = [
    {
      model_name: "Total",
      count: eDPStockcountOfCarCount.Totalcar,
      url: "/edp-stock-details",
      icon: "../assets/logos/total.png",
    },
    {
      model_name: "Pending",
      count: eDPStockcountOfCarCount.Pendingcar,
      url: "/edp-stock-details?term=Pending",
      icon: "../assets/logos/pending.png",
    },
    {
      model_name: "InTransit",
      count: eDPStockcountOfCarCount.InTransitcar,
      url: "/edp-stock-details?term=InTransit",
      icon: "../assets/logos/transit.png",
    },
    {
      model_name: "Physical",
      count: eDPStockcountOfCarCount.Physicalcar,
      url: "/edp-stock-details?term=Physical",
      icon: "../assets/logos/physical.png",
    },
    {
      model_name: "Pending Deliveries",
      count: eDPStockcountOfCarCount.PendingDeliveries,
      url: "/edp-manage-delivery",
      icon: "../assets/logos/delivered.png",
    },
  ];
  const toggelSelect = (row) => {
    const updatedData = tableData.map((item) => {
      if (item.VinNumber === row.VinNumber) {
        return { ...item, enabled: !item.enabled, error: "" };
      }
      return item;
    });

    setTableData(updatedData);

    // Reset errors when toggling selection
    setErrors({});
  };

  const handleInputChange = (index, field, value) => {
    const updatedData = [...tableData];
    updatedData[index][field] = value;
    updatedData[index]["error"] = "";
    setTableData(updatedData);
  };

  const transformData = (data) => {
    const result = [];
    data.forEach((item) => {
      const vinNumbers = item.OrderNo.split(","); // Split comma-separated VINs
      vinNumbers.forEach((vin) => {
        result.push({
          Model: item.Model,
          varient: item.Variant?.trim(),
          SpecificationCode: item.FullSpecCode,
          OrderNO: vin,
        });
      });
    });
    return result;
  };
  const updateAllDetails = () => {
    if (validateInput()) {
      const enabledData = tableData.filter((item) => item.enabled);
      const finalData = transformData(enabledData);
      updateExcel(finalData); // Proceed with the update
    } else {
      console.log("Validation failed");
    }
  };
  const isDisabled = tableData.filter((item) => item.enabled).length === 0;
  // Add space after each comma
  const formattedVinNumbers = (vinNumbers) => vinNumbers.replace(/,/g, ", ");

  return (
    <>
      {message && (
        <SuccessMessage
          onClose={() => setMessage("")}
          message={successMessage()}
          apiFailled={apiFailled}
        />
      )}

      <Modal
        type="EDD stock add"
        setOpen={() => {
          setErrorReason("");
          setReason("");
          setShowModal(!showModal);
        }}
        open={showModal}
      >
        <div className="modal-content bg-white rounded-lg max-w-7xl w-full h-fit overflow-hidden">
          {reason && <ErrorMessage message={reason} />}

          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-semibold text-gray-800 ">
              Vehicle Data Table
            </h2>
            <button
              className="mt-4  text-red-500 "
              onClick={() => {
                setErrorReason("");
                setReason("");
                setShowModal(false);
              }} // Close the modal
            >
              <MdOutlineCancel className="h-8 w-6 -mt-6" />
            </button>
          </div>
          <div ref={tableContainerRef} className="overflow-y-auto max-h-[70vh]">
            <table className="table-auto border-collapse border border-gray-300 rounded-lg overflow-hidden w-full">
              <thead>
                <tr className="bg-blue-600 text-white">
                  <th className="border border-gray-300 p-4 text-left max-w-lg">
                    Order Number
                  </th>
                  <th className="border border-gray-300 p-4 text-left">
                    Full Spec Code
                  </th>
                  <th className="border border-gray-300 p-4 text-left">
                    Variant
                  </th>
                  <th className="border border-gray-300 p-4 text-left">
                    Select
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-100 transition-all duration-200 ease-in-out"
                  >
                    <td className="border-2 border-gray-300 p-4 max-w-lg break-words">
                      {row.OrderNo}
                    </td>
                    <td className="border-2 border-gray-300 p-4">
                      {row.FullSpecCode}
                    </td>
                    <td className="border-2 border-gray-300 p-4">
                      <input
                        type="text"
                        value={row.Variant}
                        onChange={(e) =>
                          handleInputChange(index, "Variant", e.target.value)
                        }
                        className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 ${row.error ? "border-red-500" : "border-gray-300"
                          }`}
                        placeholder="Enter variant"
                        disabled={!row.enabled} // Disable input for unchecked rows
                      />
                      {row.error && (
                        <p className="text-red-500 text-sm">{row.error}</p>
                      )}
                    </td>
                    <td className="border-2 border-gray-300 p-4">
                      <div className="flex items-center justify-center space-x-2">
                        <input
                          type="checkbox"
                          id={`checkbox-${index}`}
                          checked={row.enabled}
                          onChange={() => toggelSelect(row)}
                          className="w-5 h-5 cursor-pointer text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-6 flex items-center justify-between">
            <div></div>
            <div className="text-red-500 text-sm font-semibold">
              {errorRreason}
            </div>

            <button
              type="button"
              onClick={() => updateAllDetails()}
              disabled={isDisabled}
              className={`bg-green-500 text-white px-6 py-3 rounded-lg ${isDisabled
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
                }`}
            >
              Confirm Import
            </button>
          </div>
        </div>
      </Modal>

      {errorMessage && <ErrorMessage message={errorMessage} />}
      <Navbar navbarType={"blue navbar"} />
      {loading ? (
        <img
          src="../assets/loadingGif.gif"
          alt="loading"
          className={classes.loader}
        />
      ) : (
        <div className={classes.maincontainer}>
          <Heading headingType={"Page Headings"} headingText={"Dashboard"} />

          <div className={classes.background}>
            <Input
              type={"input with label"}
              inputType="file"
              label="Add Stock From Excel"
              onInput={() => (error.input = "")}
              onChange={handleChange}
            />
            <span className="error">
              {uploadError ? uploadError : error.input}
            </span>

            <div className="mt-4">
              <Button
                loading={loading}
                type="redFilled"
                buttonText="Submit"
                onClick={() =>
                  formValidation() ? excelUpdate() : console.log("err")
                }
              />
            </div>

            <div>
              <EDPNewExcelEntry newEntry={newEntry} />
            </div>

            <StatsCard
              type="EDP Total Real Time Stock ui changes"
              data={data}
              typewidth={"width"}
            />
            <div className="flex items-start my-4 gap-4">
              <EDPTableCopyClipBoard
                data={modelWiseDLD}
                caption="Model Wise Delivered"
                className=" border-indigo-600 bg-indigo-700 text-white font-semibold cursor-pointer py-2"
              />
              <EDPTableCopyClipBoard
                data={totalStockModelWise}
                caption="Total Stock Model Wise"
                className="border-pink-600 bg-pink-700 text-white font-semibold cursor-pointer py-2"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EdpDashboard;
